"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Button = _interopRequireDefault(require("../../01_atoms/Button"));

var _FormContainer = _interopRequireDefault(require("../../01_atoms/FormContainer"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _TitledContainer = _interopRequireDefault(require("../../01_atoms/TitledContainer"));

var _ResponsiveCentralPaneWrapper = _interopRequireDefault(require("../../02_molecules/ResponsiveCentralPaneWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ForgotPasswordPageUI = function ForgotPasswordPageUI(_ref) {
  var error = _ref.error,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      email = _ref.email,
      _ref$onEmailChange = _ref.onEmailChange,
      onEmailChange = _ref$onEmailChange === void 0 ? function () {} : _ref$onEmailChange,
      _ref$onResetPassword = _ref.onResetPassword,
      onResetPassword = _ref$onResetPassword === void 0 ? function () {} : _ref$onResetPassword,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('ForgotPasswordPageUI');
  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Reset your password'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_ResponsiveCentralPaneWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Reset your password'),
    rightButtonText: t('Back'),
    onRightButtonClick: onBack
  }, /*#__PURE__*/_react["default"].createElement(_FormContainer["default"], null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, {
    onSubmit: function onSubmit() {
      return onResetPassword(email);
    },
    error: !!error
  }, !!error && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
    error: true,
    header: t('Error'),
    content: error.message
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    placeholder: t('E-mail'),
    value: email,
    onChange: function onChange(e, o) {
      return onEmailChange(o.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    fluid: true,
    type: "submit",
    primary: true
  }, t('Reset password')))))));
};

var _default = ForgotPasswordPageUI;
exports["default"] = _default;